import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HoursState } from '../../types';
import { monthKey } from '../../utils/dates';

const initialState: HoursState = {
  selectedMonth: monthKey(new Date()),
  months: {},
};

const ensureMonth = (state: HoursState, month: string) => {
  state.months[month] ??= { locked: false, entries: {} };
  return state.months[month];
};

const hoursSlice = createSlice({
  name: 'hours',
  initialState,
  reducers: {
    replaceHoursState: (_state, action: PayloadAction<HoursState>) => action.payload,
    selectMonth: (state, action: PayloadAction<string>) => {
      state.selectedMonth = action.payload;
    },
    toggleLock: (state, action: PayloadAction<string>) => {
      const monthState = ensureMonth(state, action.payload);
      monthState.locked = !monthState.locked;
    },
    setMonthHours: (state, action: PayloadAction<{ month: string; userId: number; userName: string; hours: number }>) => {
      const { month, userId, userName, hours } = action.payload;
      const monthState = ensureMonth(state, month);
      const entryKey = String(userId);
      const entry = monthState.entries[entryKey] ?? {
        month,
        userId,
        userName,
        hours: 0,
        notes: '',
        updatedAt: new Date().toISOString(),
      };

      entry.userName = userName;
      entry.hours = hours;
      entry.updatedAt = new Date().toISOString();
      monthState.entries[entryKey] = entry;
    },
    setMonthNotes: (state, action: PayloadAction<{ month: string; userId: number; userName: string; notes: string }>) => {
      const { month, userId, userName, notes } = action.payload;
      const monthState = ensureMonth(state, month);
      const entryKey = String(userId);
      const entry = monthState.entries[entryKey] ?? {
        month,
        userId,
        userName,
        hours: 0,
        notes: '',
        updatedAt: new Date().toISOString(),
      };

      entry.userName = userName;
      entry.notes = notes;
      entry.updatedAt = new Date().toISOString();
      monthState.entries[entryKey] = entry;
    },
    clearMonthEntry: (state, action: PayloadAction<{ month: string; userId: number }>) => {
      const { month, userId } = action.payload;
      const monthState = ensureMonth(state, month);
      delete monthState.entries[String(userId)];
    },
    ensureMonthExists: (state, action: PayloadAction<string>) => {
      ensureMonth(state, action.payload);
    },
  },
});

export const { replaceHoursState, selectMonth, toggleLock, setMonthHours, setMonthNotes, clearMonthEntry, ensureMonthExists } = hoursSlice.actions;
export default hoursSlice.reducer;